import { Action } from '@ngrx/store';

export enum rememberPassActionTypes {
    DO_REMEMBER = '[rememberPass] Do Remember',
    DO_REMEMBER_SUCCESS = '[rememberPass] Do Remember Success',
    DO_REMEMBER_FAIL = '[rememberPass] Do Remember Fail'
}

// export const DO_RESET = '[rememberPass] Reset';
// export class DoReset implements Action {
//     readonly type = DO_RESET;

//     constructor() { }
// }


export class DoRemember implements Action {
    readonly type = rememberPassActionTypes.DO_REMEMBER;

    constructor(public email: string, public returnPath: string) { }
}


export class DoRememberSuccess implements Action {
    readonly type = rememberPassActionTypes.DO_REMEMBER_SUCCESS;

    constructor(public payload: any) { }
}


export class DoRememberFail implements Action {
    readonly type = rememberPassActionTypes.DO_REMEMBER_FAIL;

    constructor(public error: number) { }
}


export type rememberPassActions = DoRemember | DoRememberSuccess | DoRememberFail;
